import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function PageHero({ eyebrow, title, subtitle, image, height = "h-[52vh]", ctaLabel, ctaTo, testId }) {
  return (
    <section
      data-testid={testId || "page-hero"}
      className={`relative ${height} min-h-[420px] flex items-end es-grain overflow-hidden`}
    >
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[var(--es-navy)]/95 via-[var(--es-navy)]/85 to-[var(--es-navy)]/60" />
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-[var(--es-accent)]" />
      </div>
      <div className="es-container relative pb-14 md:pb-20 z-10">
        {eyebrow && (
          <div className="inline-flex items-center gap-2 mb-5 es-fade-up">
            <span className="h-px w-8 bg-[var(--es-accent)]" />
            <span className="text-xs uppercase tracking-[0.25em] text-[var(--es-accent)] font-semibold">{eyebrow}</span>
          </div>
        )}
        <h1 className="es-h1 text-white max-w-4xl es-fade-up" style={{ animationDelay: "0.05s" }}>{title}</h1>
        {subtitle && (
          <p className="mt-5 text-white/80 text-lg max-w-2xl es-fade-up" style={{ animationDelay: "0.15s" }}>
            {subtitle}
          </p>
        )}
        {ctaLabel && ctaTo && (
          <div className="mt-8 es-fade-up" style={{ animationDelay: "0.25s" }}>
            <Link to={ctaTo} className="es-btn-accent" data-testid="page-hero-cta">
              {ctaLabel} <ArrowRight size={18} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
